import { FilterSection, FilterSort } from '@/types';

export type State = {
    loadingProductsLabel: string;
    filterTitle: string;
    cancelFilterLabel: string;
    sections: FilterSection[];
    sort: FilterSort | null;
    url: string;
    categorySortLabel: string,
    resultsTotalCount: number;
    resultsTotalLabel: string;
    showMoreLabel: string;
    showLessLabel: string;
    isOpenedFilterModal: boolean;
}

export const state: State = {
    loadingProductsLabel: "",
    filterTitle: "",
    cancelFilterLabel: "",
    sections: [],
    sort: null,
    url: "",
    categorySortLabel: "",
    resultsTotalCount: 0,
    resultsTotalLabel: "",
    showMoreLabel: "",
    showLessLabel: "",
    isOpenedFilterModal: false,
};
